import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
   apiKey: "AIzaSyB8iwNdOkhSGphpenrNs2QZzkQ4Ra0I558",
  authDomain: "ladderemsrn.firebaseapp.com",
  databaseURL: "https://ladderemsrn-default-rtdb.firebaseio.com",
  projectId: "ladderemsrn",
  storageBucket: "ladderemsrn.appspot.com",
  messagingSenderId: "723883265845",
  appId: "1:723883265845:web:716064da339b18bbd6867c",
  measurementId: "G-2CFH80WDVF"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging
const messaging = getMessaging(app);

export const requestPermission = () => {
  Notification.requestPermission().then((permission) => {
    if (permission === "granted") {
      getToken(messaging, {
        vapidKey: `BD9uElIt7zxieomiyDPJsfPO3K53fXP3nfzcJVkptHed80VCVFnddN5aA87EBqi91aamLQGT0X3IP68c46pp0a8`,
      })
        .then((currentToken) => {
          if (currentToken) {
            console.log(currentToken);
            window.localStorage.setItem("token", currentToken);
          } else {
            console.log("Failed to generate the app registration token.");
          }
        })
        .catch((err) => {
          console.log(
            "An error occurred when requesting to receive the token.",
            err
          );
        });
      return;
    } else {
      console.log("User Permission Denied.");
    }
  });
};

requestPermission();

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });

// Initialize Firebase Services
export const db = getFirestore(app);
export const auth = getAuth();
export const storage = getStorage(app);
